import mqtt from 'mqtt';
import { useState, useEffect, useCallback } from 'react';

const MQTTService = () => {
  const [client, setClient] = useState(null);
  const [connectStatus, setConnectStatus] = useState('Disconnected');
  const [payload, setPayload] = useState(null);

  const mqttConnect = useCallback((host, mqttOption) => {
    if (!client) {
      console.log('Connecting to MQTT broker...');
      const newClient = mqtt.connect(host, mqttOption);
      setClient(newClient);
      setConnectStatus('Connecting');
    }
  }, [client]);

  const mqttDisconnect = useCallback(() => {
    if (client) {
      console.log('Disconnecting from MQTT broker...');
      client.end();
      setClient(null);
      setConnectStatus('Disconnected');
    }
  }, [client]);

  const mqttSub = useCallback(
    (subscription) => {
      if (client) {
        const { topic, qos } = subscription;
        console.log(`Subscribing to topic: ${topic} with QoS: ${qos}`);
        client.subscribe(topic, { qos }, (error) => {
          if (error) {
            console.log('Subscribe to topics error', error);
          } else {
            console.log(`Subscribed to topic: ${topic}`);
          }
        });
      }
    },
    [client]
  );

  const mqttUnSub = useCallback(
    (subscription) => {
      if (client) {
        const { topic } = subscription;
        console.log(`Unsubscribing from topic: ${topic}`);
        client.unsubscribe(topic, (error) => {
          if (error) {
            console.log('Unsubscribe error', error);
          } else {
            console.log(`Unsubscribed from topic: ${topic}`);
          }
        });
      }
    },
    [client]
  );

  useEffect(() => {
    if (client) {
      client.on('connect', () => {
        console.log('Connected to MQTT broker');
        setConnectStatus('Connected');
      });
      client.on('reconnect', () => {
        console.log('Reconnecting to MQTT broker');
        setConnectStatus('Reconnecting');
      });
      client.on('error', (err) => {
        console.error('Connection error: ', err);
        if (err.message.includes('Insufficient resources')) {
          console.error('Broker resource limit reached. Retrying...');
          setTimeout(() => client.reconnect(), 10000);
        } else {
          client.end();
        }
      });
      client.on('message', (topic, message) => {
        console.log(`Received message on topic: ${topic} - ${message.toString()}`);
        setPayload({ topic, message: message.toString() });
      });

      return () => {
        console.log('Cleaning up MQTT client');
        client.removeAllListeners();
        client.end();
      };
    }
  }, [client]);

  return {
    connectStatus,
    payload,
    mqttConnect,
    mqttSub,
    mqttUnSub,
    mqttDisconnect,
  };
};

export default MQTTService;